import { gridSizeMdLg4, newBodegasSchema } from '@/shared';
import {
  useCreateBodegas,
  useFetchAllCountries,
  useFetchCitiesEnabled,
  useFetchProvinces,
  useFetchSectors,
  useFetchZones,
  useUpdateBodegas,
} from '@/shared/actions/erp';
import {
  CustomAutocomplete,


  CustomTextField,


  SingleTableBoxScene,
  SwitchComponenteForm,
} from '@/shared/components/ui';
import { City, Country, Province, Sector, Zone } from '@/shared/interfaces';
import { BODEGAS, TiposBodegaEnum } from '@/shared/interfaces/erp/inventario';
import { useAuthStore } from '@/store/auth';
import { useUiStore } from '@/store/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

const returnUrlBodegas = '/inventario/bodegas';

export interface SaveBodegasProps {
  titlePage: string;
  editBodegas?: BODEGAS;
}

type SaveFormData = {
  nombre: string;
  direccion: string;
  estado: boolean;
  es_externa: boolean;
  pais: string;
  ciudad: string;
  provincia: string;
  zona: string;
  sector: string
  es_transito: boolean;
  es_concecion_cliente: boolean;
  email?: string | null;
  es_cliente?: boolean;
};

const SaveBodegas: React.FC<SaveBodegasProps> = ({
  titlePage,
  editBodegas,
}) => {

  //get email user
  const email_receptor = useAuthStore.getState().user?.email ?? '';
  console.log('receptor', email_receptor)
  //
  const navigate = useNavigate();

  //*local state
  const [shrink, setShrink] = useState(false);

  ///* global state
  //* stepper

  const setAlert = useUiStore(s => s.setAlert);


  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newBodegasSchema),
    defaultValues: {
      es_transito: false,
      es_concecion_cliente: false
    }
  });
  const watchedCountry = form.watch('pais');
  const watchedProvince = form.watch('provincia');
  const watchedCity = form.watch('ciudad');
  ///* fetch data
  const {
    data: countriesPaging,
    isLoading: isLoadingCountries,
  } = useFetchAllCountries({
    page_size: 600,
  });
  const {
    data: sectorPaging,
    isLoading: isLoadingSector,
  } = useFetchSectors({
    page_size: 600,
  });
  const {
    data: provincesPaging,
    isLoading: isLoadingProvinces,
  } = useFetchProvinces(
    {
      page_size: 600,
      pais: watchedCountry,
    },
    !!watchedCountry
  );
  const {
    data: citiesPaging,
    isLoading: isLoadingCities,
  } = useFetchCitiesEnabled(
    {
      params: {
        page_size: 600,
        provincia: watchedProvince,
        pais: watchedCountry,
      },
      enabled: !!watchedProvince && !!watchedCountry
    }
  );
  const {
    data: zonesPaging,
    isLoading: isLoadingZones,
  } = useFetchZones(
    {
      page_size: 600,
      ciudad: watchedCity,
    },
    !!watchedCity
  );

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;
  ///* mutations
  const createBodegas = useCreateBodegas({
    navigate,
    returnUrl: returnUrlBodegas,
  });
  const updateBodegas = useUpdateBodegas({
    navigate,
    returnUrl: returnUrlBodegas,
  });
  //TiposBodegaEnum.BODEGA_MATRIZ_QUITO
  ///* handlers
  const onSave = () => {
    const value = form.getValues()
    if (value.nombre === TiposBodegaEnum.BODEGA_MATRIZ_QUITO) {
      if (!editBodegas?.id_bodega || !value.email) {
        form.setValue('email', email_receptor)
      }
    }
    if (!isValid) return;
    if (editBodegas?.id_bodega) {
      ///* upd
      return updateBodegas.mutate({
        id: editBodegas.id_bodega,
        data: {
          ...form.getValues(),
        } as any,
      });
    }
    ///* create
    return createBodegas.mutate({
      ...(form.getValues() as any),
    });
  };
  ///*fetch
  //effets
  useEffect(() => {
    if (editBodegas?.id_bodega) {
      setShrink(true);
      reset({
        ...editBodegas
      })
    }

  }, [editBodegas, form])

  return (
    <>
      <SingleTableBoxScene
        title={titlePage}
        enableBackBtn={true}
        backPageUrl="/inventario/bodegas"
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, (error) => {
          console.log(error)
          setAlert(true, 'Faltan campos por llenar', 'error');
        })}
      >
        <Grid container spacing={2}>
          <CustomTextField
            label="Nombre"
            name="nombre"
            control={form.control}
            defaultValue={form.getValues().nombre || ''}
            error={errors.nombre}
            helperText={errors.nombre?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />

          <CustomTextField
            label="Direccion"
            name="direccion"
            control={form.control}
            defaultValue={form.getValues().direccion || ''}
            error={errors.direccion}
            helperText={errors.direccion?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />


          <CustomAutocomplete<Country>
            label="Pais"
            name="pais"
            actualValueKey="codigo"
            //// options
            options={countriesPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            //
            defaultValue={form.getValues().pais || ""}
            optionLabelForEdit={form.getValues().pais || ""}
            isLoadingData={isLoadingCountries}
            //// validation
            control={control}
            error={errors.pais}
            helperText={errors.pais?.message}
            onChangeValue={(e) => { form.setValue("pais", e) }}
            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<Province>
            label="Provincia"
            name="provincia"
            actualValueKey="codigo"
            //// options
            options={provincesPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            //
            defaultValue={form.getValues().provincia || ""}
            optionLabelForEdit={form.getValues().provincia || ""}
            isLoadingData={isLoadingProvinces}
            //// validation
            control={control}
            error={errors.provincia}
            helperText={errors.provincia?.message}
            onChangeValue={(e) => { form.setValue("provincia", e) }}
            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<City>
            label="Ciudad"
            name="ciudad"
            actualValueKey="codigo"
            //// options
            options={citiesPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            //
            defaultValue={form.getValues().ciudad || ""}
            optionLabelForEdit={form.getValues().ciudad || ""}
            isLoadingData={isLoadingCities}
            //// validation
            control={control}
            error={errors.ciudad}
            helperText={errors.ciudad?.message}
            onChangeValue={(e) => { form.setValue("ciudad", e) }}
            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<Zone>
            label="Zona"
            name="zona"
            actualValueKey="codigo"
            //// options
            options={zonesPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            //
            defaultValue={form.getValues().zona || ""}
            optionLabelForEdit={form.getValues().zona || ""}
            isLoadingData={isLoadingZones}
            //// validation
            control={control}
            error={errors.zona}
            helperText={errors.zona?.message}
            onChangeValue={(e) => { form.setValue("zona", e) }}
            size={gridSizeMdLg4}
          />
          <CustomAutocomplete<Sector>
            label="Sector"
            name="sector"
            actualValueKey="codigo"
            //// options
            options={sectorPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            //
            defaultValue={form.getValues().sector || ""}
            optionLabelForEdit={form.getValues().sector || ""}
            isLoadingData={isLoadingSector}
            //// validation
            control={control}
            error={errors.sector}
            helperText={errors.sector?.message}
            onChangeValue={(e) => { form.setValue("sector", e) }}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            label='Correo Electrónico'
            name="email"
            control={control}
            error={errors.email}
            helperText={errors.email?.message}
            //shrink={true}
            type='email'
            size={gridSizeMdLg4}

          />
          <SwitchComponenteForm
            control={control}
            defaultValue={form.getValues().es_externa || true}
            label={"Es externa"}
            name="es_externa"
            size={gridSizeMdLg4}
          />
          <SwitchComponenteForm
            control={control}
            defaultValue={form.getValues().estado || true}
            label={"Estado"}
            name="estado"
            size={gridSizeMdLg4}
          />
          <SwitchComponenteForm
            control={control}
            defaultValue={form.getValues().es_transito || true}
            label={"Bodega en transito"}
            name="es_transito"
            size={gridSizeMdLg4}
          />
          <SwitchComponenteForm
            control={control}
            defaultValue={form.getValues().es_concecion_cliente || true}
            label={"Bodega Concepción Cliente"}
            name="es_concecion_cliente"
            size={gridSizeMdLg4}
          />
          <SwitchComponenteForm
            control={control}
            defaultValue={form.getValues().es_cliente || false}
            label={"Es Cliente"}
            name="es_cliente"
            size={gridSizeMdLg4}
          />
        </Grid>
      </SingleTableBoxScene>
    </>
  );
};
export default SaveBodegas;
